<template>
  <div v-if="survey && recipient">
    <div v-if="!recipient.completed_at">
      <div class="not-completed position-absolute">
        <span>Survey not completed yet.</span>
      </div>
    </div>
    <SurveyComplete v-else :recipient="recipient" :survey="survey" />
  </div>
</template>

<script lang="ts">
import SurveyComplete from './SurveyComplete.vue'
import * as api from '@/survey/api.js'

export default {
  components: { SurveyComplete },
  props: {
    recipientToken: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      survey: null,
    }
  },
  async mounted() {
    const response = await api.signInAndGetRecipient(this.recipientToken)
    this.survey = response.data.survey
  },
  computed: {
    recipient() {
      return this.survey.recipients.find((r) => r.token == this.recipientToken)
    },
  },
}
</script>
<style lang="sass" scoped>
.not-completed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
</style>
